export class ProfileInfo {
    activeProfiles: string[];
    ribbonEnv: string;
    inProduction: boolean;
    swaggerEnabled: boolean;
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/layouts/profiles/profile-info.model.ts